<div class="invoice-resend-email-modal px-6!">
  <div class="invoice-resend-email-modal__header">
    <mat-icon (click)="close()">close</mat-icon>
  </div>
  <div class="invoice-resend-email-modal__body">
    @if (isIdle()) {
      <app-horus-message-general
        nameIcon="confirmResendEmailIcon"
        btnAction="CONFIRMAR"
        size="M"
        (action)="sendEmail()"
        btnCancel="CANCELAR"
        (actionCancel)="close()">
        Estás a punto de reenviar este comprobante de pago al correo
        <p><strong>{{clientEmail()}}</strong></p>
        ¿Quieres confirmar su <strong>reenvío</strong>?
      </app-horus-message-general>
    }

    @if (isSending()) {
      <div class="loading-container">
        <app-horus-loading [size]="'S'"></app-horus-loading>
        <p>Enviando comprobante...</p>
      </div>
    }

    @if (isSuccess()) {
      <app-horus-message-general
        nameIcon="successMessageIcon"
        btnAction="¡LISTO!"
        size="M"
        (action)="closeSuccess()">
        <p class="title-ok">¡Completado!</p>
        Enviaste el comprobante de pago de manera correcta al correo del cliente.
      </app-horus-message-general>
    }

    @if (isError()) {
      <app-horus-message-general
        nameIcon="errorMessageIcon"
        btnAction="INTENTAR NUEVAMENTE"
        size="M"
        (action)="retry()"
        btnCancel="CANCELAR"
        (actionCancel)="close()">
        <p class="title-error">Lo sentimos</p>
        Hubo un error al intentar enviar el correo junto al comprobante de pago.
      </app-horus-message-general>
    }
  </div>
</div>
